var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home",on:{"scroll":function($event){return _vm.scrollHandle($event)}}},[_c('Header',{attrs:{"headerHeight":_vm.headerHeight}}),_c('div',{ref:"viewContent",class:['viewContent', { overflow: _vm.overflow }]},[_c('router-view')],1),_c('Tabs',{attrs:{"showTab":_vm.showTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }